import { Stack } from './stack'
import { getPriority, getReverse, isOperator } from './_utils'

export function infixToPrefix(infix = []) {
  const prefix = []

  /**
   * step 1:
   *  Replacing '(' with ')' and (we don't have parenthesis)
   *  reversing the input string (in out case: array)
   */
  const reversedInfix = getReverse(infix)

  // Declaration of stack
  const stack = new Stack(reversedInfix.length)

  for (const item of reversedInfix) {
    // 1. If item is '(' push it to stack
    if (item.operator === '(') {
      stack.push(item)
    }

    // 2. if character is ')' pop out elements
    // from stack until '(' is found or
    // the stack becomes empty
    else if (item.operator === ')') {
      let token = stack.top()
      while (stack.topIndex > -1 && token !== '(') {
        prefix.push(stack.pop())
        token = stack.top()
      }
      stack.pop()
    }

    // 3. if the item is a digit or alphabet (operand)
    // add it to the answer string (array)
    else if (!isOperator(item)) {
      prefix.push(item)
    }

    // 4. if the item is any operator
    // pop out elements from stack until
    // the stack is empty or a symbol with
    // a higher precedence is found in the stack
    else if (isOperator(item)) {
      let token = stack.top()
      while (stack.topIndex > -1 && getPriority(item) <= getPriority(token)) {
        prefix.push(stack.pop())
        token = stack.top()
      }
      stack.push(item)
    }
  }

  // 5. Pop out all remaining elements in
  // the stack and add it to answer string (array)
  while (stack.topIndex > -1) {
    prefix.push(stack.pop())
  }

  // Return the reversed answer string
  return getReverse(prefix)
}

export const prefixToWhenObject = (prefix) => {
  let outputStack = []

  // 1. Start from the last element of the expression.
  const items = getReverse(prefix)

  for (const item of items) {
    // 2. check the current element.
    // 2.1. if it is an operand, push it to the stack.
    if (!isOperator(item)) {
      outputStack.push(item)
    } else {
      // 2.2. If it is an operator
      // 2.2.1. pop two operands from the stack,
      //        create an operation object (Perform the operation)
      //        and push the elements back to the stack.

      const operation = item.operator
      let args = [outputStack.pop(), outputStack.pop()]

      // ==== experimental
      // if operations are the same, we can merge the args instead of nesting another level
      if (operation === args[1].operation) {
        args = [args[0], ...args[1].args]
      }
      // ==== experimental

      outputStack.push({ operation, args })
    }

    // repeat this till all the elements of the expression are traversed and
  }

  // return the top of stack which will be the result of the operation.
  return outputStack[0]
}

export default function getNestedWhenObject(infix) {
  const prefix = infixToPrefix(infix)
  return prefixToWhenObject(prefix)
}
